import { CaretRightIcon } from '@phosphor-icons/react'

import { Button } from '@components/shared/Button'

import { WEEK_STATUS_CONFIG } from '../statusConfig'

import type { WeekStatusCardProps } from './types'

import * as S from './styles'

export const WeekStatusCard = ({
  weekLabel,
  totalUnits,
  statuses,
  isCurrentWeek,
  isSelected,
  isLoadingUnits,
  onSelect,
  onViewUnits
}: WeekStatusCardProps) => {
  return (
    <S.Container isCurrentWeek={isCurrentWeek} isSelected={isSelected} onClick={onSelect}>
      <S.Header>
        <S.WeekTitle>
          <S.WeekLabel>{weekLabel}</S.WeekLabel>
          {isCurrentWeek && <S.CurrentWeekBadge>Semana atual</S.CurrentWeekBadge>}
        </S.WeekTitle>
        <S.UnitsBadge>{totalUnits === 1 ? '1 Unid' : `${totalUnits} Unids.`}</S.UnitsBadge>
      </S.Header>

      <S.StatusList>
        {statuses.map((status) => {
          const config = WEEK_STATUS_CONFIG[status.code]

          return (
            <S.StatusRow key={status.code}>
              <S.StatusLabel>
                <S.Dot color={config.color} />
                <S.StatusIcon style={{ color: config.color }}>{config.icon}</S.StatusIcon>
                {status.label}
              </S.StatusLabel>

              <S.CountBadge style={{ color: config.color, background: config.background }}>
                {status.count}
              </S.CountBadge>
            </S.StatusRow>
          )
        })}
      </S.StatusList>

      {isSelected && (
        <Button
          colorType="outlineBlue"
          width="100%"
          rightIcon={<CaretRightIcon size={16} weight="bold" />}
          loading={isLoadingUnits}
          disabled={isLoadingUnits}
          onClick={(event) => {
            event.stopPropagation()
            onViewUnits()
          }}
        >
          Ver unidades
        </Button>
      )}
    </S.Container>
  )
}
